import { DefaultLine } from "./DefaultLine";
import { DiscountLine } from "./DiscountLine";
import { EndingBalanceLine } from "./EndingBalanceLine";
import { FreeTrialLine } from "./FreeTrialLine";
import { PaidTrialLine } from "./PaidTrialLine";
import { SubtotalLine } from "./SubtotalLine";
import { TaxLine } from "./TaxLine";
import { TodayPaymentLine } from "./TodayPaymentLine";
import { TotalDueTodayLine } from "./TotalDueTodayLine";

export const Lines = Object.assign(
  {},
  {
    DefaultLine,
    EndingBalanceLine,
    FreeTrialLine,
    PaidTrialLine,
    SubtotalLine,
    TaxLine,
    DiscountLine,
    TodayPaymentLine,
    TotalDueTodayLine,
  },
);
